/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-03 09:45:59
 * @LastEditors: caiqin.xie
 * @message: 配件-banner组件
 */
import React from "react";
import { useDevice } from "@/hooks";
import styles from "../../index.module.scss";
import { IBanner } from "@/common/types";
import LazyMedia from "@/components/LazyMedia";
interface IProps {
  banner: IBanner;
  ctry: string;
  words: Record<string, string>;
}

const Banner = (props:IProps) => {
  const {ctry, words, banner} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
      {banner && (
        <div className={styles['banner-wrap']}>
          {
            banner[newDevice].extension === '.mp4'
            ? <LazyMedia type="video" LazyClassName='full-wh' loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url}></LazyMedia>
            : <LazyMedia type="image" LazyClassName='full-wh' src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} />
          }
          <div className={styles['banner-content']}>
            {banner?.isShowTitle === 1 && (
              <h1 className={styles['banner-title']}>{banner?.name}</h1>
            )}
            <p className={styles['banner-desc']}>{banner?.briefIntroduction}</p>
          </div>
        </div>
      )}
    </>
  )
}
export default Banner
